import { render, staticRenderFns } from "./DigitalSignCard.vue?vue&type=template&id=2f12e6bb"
import script from "./DigitalSignCard.vue?vue&type=script&lang=js"
export * from "./DigitalSignCard.vue?vue&type=script&lang=js"
import style0 from "./kyc.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports